"use strict";

var filter = require("./filter.js");

var curry = require("./curry.js");

var go1 = require("./go1.js");

var not = require("./not.js");

module.exports = curry(function reject(f, iter) {
  return filter(a => go1(f(a), not), iter);
});